import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/devlog/[slug]/_components/controllers/NavigationUpdater.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/brief/brief.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/brief/BriefArchive.tsx");
